// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__Akkq5","messages":"Chat_messages__1NmLj","dateDivider":"Chat_dateDivider__2hlBt"};